export enum PdfLayoutOptions {
    Standard = "Standard",
    Avery94224 = "Avery94224",
    Avery22806 = "Avery22806",
}

export enum PdfBarcodeFormatOptions {
    QRCode = "QRCode",
    Code39 = "Code39",
    None = "None",
}

export enum PdfBarcodeDataFieldOptions {
    URL = "URL",
    ErpNumber = "ErpNumber",
    CustomerName = "CustomerName",
    ManufacturerItem = "ManufacturerItem",
    BinNumber = "BinNumber",
}

export interface BasePdfApiParameter {
    lineIds?: string[];
    layout: PdfLayoutOptions;
    barcodeFormat: PdfBarcodeFormatOptions;
    barcodeField: PdfBarcodeDataFieldOptions;
    displayFields?: string[];
    addOverlay?: boolean;
}
